export const CALL_CONSENT_NOT_SET = null;
export const CALL_CONSENT_COMPANIES_ONLY = 0;
export const CALL_CONSENT_BOTH = 1;
